import React, { useEffect, useState } from 'react'
import { useAppSelector } from 'app/hooks'
import { RootState, Availability, AvailabilityAnalytics } from 'app/types'
import { AnalyticsBarChart } from 'views/AdminPage/Analytics/AnalyticsBarChart'

interface AvailabilityAnalyticsTileProps {
    app: AppData,
    data: AvailabilityAnalytics[],
}

export function AvailabilityAnalyticsTile(props:AvailabilityAnalyticsTileProps) {
    const { app, data } = props
    const availabilityStates = app.meta.availabilityStates
    const [chartData, setChartData] = useState(null)

    useEffect(() => {
        const stateMap = {}
        for (let i = 0; i < availabilityStates.length; i += 1) {
            stateMap[availabilityStates[i].id] = availabilityStates[i].name
        }

        const finalUnits: {[key:string]: AvailabilityAnalytics} = {}
        // Collapse data to get most recent status of each
        for (let i = 0; i < data.length; i += 1) {
            if (!(data[i].unitId in finalUnits)) {
                finalUnits[data[i].unitId] = data[i]
            } else {
                const currentDate = Date.parse(finalUnits[data[i].unitId].dateChanged)
                const newDate = Date.parse(data[i].dateChanged)
                if (newDate > currentDate) {
                    finalUnits[data[i].unitId] = data[i]
                }
            }
        }

        const finalData = []
        const units = Object.keys(finalUnits)
        for (let i = 0; i < units.length; i += 1) {
            const unit = finalUnits[units[i]]
            if (stateMap[unit.availabilityStateId] === Availability.Sold) {
                finalData.push(unit)
            }
        }
        setChartData(finalData)
    }, [])

    if (chartData == null) {
        return null
    }

    return <div className="analytics-tile">
        <AnalyticsBarChart title="Units Sold" data={chartData} dateKey="dateChanged" dataKey="Sold" textColor="#fff"/>
    </div>
}